import { mapGetters,mapActions } from "vuex";
import { types as Home } from "@/store/home";
import { uleUrl } from "@/libs/common";
import { freshHomeDate , selfPickupSiteList, checkCart} from "@/libs/api.js";
const getters = mapGetters({
  getCurrentCity: Home.CURRENT_CITY,
  getCurrentAdCode: Home.AD_CODE,
  getCurrentCityByMin: Home.CURRENT_CITY_MIN,
  getCurrentAdCodeByMin: Home.AD_CODE_MIN,
});
const actions = mapActions({
  setCartNumber: Home.CART_NUMBER,
});
export default {
  name: "Home",
  data() {
    return {
      sitePop:false,
      loading: false,
      finished: false,
      isClick:false,
      imagesBnaner:[],
      goodsList:[],//商品数据
      querySiteParams:{
        longitude:'',//经度 121.586118
        latitude:'',//纬度  31.29371
        radius:'',//查询半径   	默认查询距离50公里
        areaId:'',//定位区
        cityId:'310100',//定位市
        provinceId:'310000',//定位省
        sort:'0',//排序字段   网点按距离远近排序。0:升序（默认）, 1:降序
        siteKeyword:'',//搜索关键字  浦东新区浦江东旭公寓
        pageIndex:'1',//页号
        pageSize:'10',//每页显示数
        teamFlag:'1'
      },
      siteList:"",//自提点列表
      siteData:{},//选择的自提点
      minMessage: {
        title: "",
        desc: "",
        link: "",
        imgUrl: "",
      },
    };
  },
  computed: {
    ...getters,
  },
  methods: {
    // 商品详情页跳转
    viPage(listId) {
      this.$router.push({
        path: "/item/itemPage/" + listId,
        query:this.$route.query
      });
    },
    // 获取首页数据
    getPageData(adcode) {
      freshHomeDate(adcode,'wap').then((res)=>{
        this.goodsList = res.listings
        res.banners.forEach(item => {
          if (~item.imgUrl.indexOf("http://")) {
            item.imgUrl = item.imgUrl.replace("http://", "https://");
          }
        });
        this.imagesBnaner = res.banners;
        this.minMessage = {
          title: "邮乐优鲜",
          desc: "邮乐优鲜",
          link: this.getCurrentLink(`https://h5.${this.$uleUrl()}/yxd/community/freshHome`),
          imgUrl: this.imagesBnaner[0].imgUrl,
        }
        // 小程序环境
        if (this.$browser().miniprogram) {
          window.wx.miniProgram.postMessage({ data: this.minMessage });
        }else {// H5环境
          window.setWeiXinShare(this.minMessage);
        }        
      })
    },
    
    // 获取自提点
    selfPickupSite(adcode) {
      let that = this;
      if (that.isClick) {
        return false
      }
      that.isClick = true
      selfPickupSiteList(this.querySiteParams,'site').then((res)=>{
        that.isClick = false        
        that.loading = false
        if(res.data && res.data.result){
          if (that.querySiteParams.pageIndex > 1) {
            that.siteList = that.siteList.concat(res.data.result);
          }else{
            that.siteList = res.data.result;
          }
        }else{
          that.siteList = []
        }
        if (!res.data || that.querySiteParams.pageIndex >= res.data.totalPages) {
          that.finished = true
        }
        if(adcode){
          that.siteData = that.siteList[0] || {}
          let selectSite = {
            location: that.siteData.geoPoint,
            siteId: that.siteData.siteId,
            adcode:that.siteData.areaId
          }
          document.cookie = `selectSite=${JSON.stringify(selectSite)};domain=.${uleUrl()};path=/;`;
          // that.getPageData(adcode);
        }
      },()=>{
        that.isClick = false
      })
    },
    searchSite(){//查询自提点
      if (this.querySiteParams.siteKeyword) {
        this.loading = true
        this.finished = false
        this.querySiteParams.pageIndex = 1
        this.selfPickupSite()
      }
    },
    moreSite(){//加载更多
      if (this.isClick) {
        return false
      }
      this.querySiteParams.pageIndex++
      this.selfPickupSite()
    },
    selectSite(site){
      this.siteData = site
      let selectSite = {
        location: this.siteData.geoPoint,
        siteId: this.siteData.siteId,
        adcode:this.siteData.areaId
      }
      document.cookie = `selectSite=${JSON.stringify(selectSite)};domain=.${uleUrl()};path=/;`;
      this.closePop()
    },
    closePop(){
      this.sitePop = false
    },
    openPop(){
      this.querySiteParams.pageIndex = 1
      this.querySiteParams.siteKeyword = ''
      this.selfPickupSite()
      this.sitePop = true
    }
  },
  mounted() {
      // this.getRecommend();
      // 小程序环境
      if (this.$browser().miniprogram) {
        let arr = (this.getCurrentCityByMin.location || '').split(',')
        this.querySiteParams.latitude = arr[0];
        this.querySiteParams.longitude = arr[1]
        this.querySiteParams.areaId = this.getCurrentAdCodeByMin;
        this.selfPickupSite(this.getCurrentAdCodeByMin);
        this.getPageData(this.getCurrentAdCodeByMin);
      }else{
        if (this.getCurrentAdCode) {
          let arr = (this.getCurrentCity.location || '').split(',')
          this.querySiteParams.latitude = arr[0];
          this.querySiteParams.longitude = arr[1]
          this.querySiteParams.areaId = this.getCurrentAdCode;
          this.selfPickupSite(this.getCurrentAdCode);
          this.getPageData(this.getCurrentAdCode);
          
        } else {
          this.$router.push("/others/positionLost");
        }
      }
  },
};
